module.exports = __webpack_public_path__ + "img/collections.e77665e6.png";